module.exports = __webpack_public_path__ + "img/Shy.fda3b9f7.png";